import React from "react";
import { useCallback } from "react";

// 함수 실행에 딜레이를 주는 함수
export function useDebounce(fn: Function, delay: number) {
  const timeoutRef = React.useRef<NodeJS.Timeout>();

  const debouncedFn = useCallback(
    (...args: any[]) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        fn(...args);
      }, delay);
    },
    [fn, delay],
  );

  return debouncedFn;
}
